import * as React from 'react';
import { Link } from 'react-router-dom';
import '../Modals.css';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';

export interface RegisterComponentProps {
  handleChange: (key: string) => ((value: string | boolean) => void);
  handleSubmit: () => void;
  login: () => void;
  termsAndConditions: boolean;
  publicity: boolean;
  error: boolean;
  errorMessage: {};
  modalRef?: Modal;
}

class RegisterComponent extends React.PureComponent<RegisterComponentProps> {

  public render(): React.ReactNode {
    return (
      <div className="modal-content">
        <div className="modal-header">
          <p className="text-right">
            <span
              className="close-med pointer"
              onClick={() => this.props.modalRef!.modal('hide')}
            />
          </p>
          <img
            src="/img/the-crowd-angel.png"
            alt="logo"
          />
          <div className="gap-20" />
          <hr />
        </div>
        <div className="modal-body">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.props.handleSubmit();
            }}
          >
            <h3 className="deco-title c-black-text">
              Regístrate
            </h3>
            <div className="gap-20" />
            <p>
              <strong>
                ¡Conoce las mejores oportunidades de inversión!
              </strong>
              <br />
              Rellena el formulario y conoce las mejores oportunidades de inversión.
            </p>
            <div className="row">
              <div className="col-sm-6">
                <div className="md-input">
                  <input
                    className="md-form-control"
                    required={true}
                    type="text"
                    onChange={(e) => this.props.handleChange('name')(e.target.value)}
                  />
                  <span className="highlight" />
                  <span className="bar" />
                  <label>Nombre *</label>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="md-input">
                  <input
                    className="md-form-control"
                    required={true}
                    type="text"
                    onChange={(e) => this.props.handleChange('surname')(e.target.value)}
                  />
                  <span className="highlight" />
                  <span className="bar" />
                  <label>
                    Apellido/s *
                  </label>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="md-input">
                  <input
                    className="md-form-control"
                    required={true}
                    type="text"
                    onChange={(e) => this.props.handleChange('email')(e.target.value)}
                  />
                  <span className="highlight" />
                  <span className="bar" />
                  <label>
                    Email *
                  </label>
                </div>
              </div>
              <div className="col-sm-6">
                <div
                  className="md-input"
                  data-container="body"
                  data-html="true"
                  data-trigger="hover"
                  data-toggle="popover"
                  data-placement="bottom"
                  data-content={this.getTooltip()}
                >
                  <input
                    className="md-form-control"
                    required={true}
                    type="password"
                    onChange={(e) => {
                      this.props.handleChange('password')(e.target.value);
                      this.props.handleChange('confirmPassword')(e.target.value);
                    }}
                  />
                  <span className="highlight" />
                  <span className="bar" />
                  <label>
                    Contraseña *
                  </label>
                </div>
              </div>
            </div>
            <div className="gap-20" />
            <div className="checkbox">
              <input
                type="checkbox"
                checked={this.props.termsAndConditions}
              />
              <label onClick={(e) => this.props.handleChange('termsAndConditions')(!this.props.termsAndConditions)}>
                He leído y acepto los&nbsp;
                <Link
                  to="/terminos-y-condiciones"
                  data-dismiss="modal"
                >
                  términos y condiciones de uso
                </Link>
                &nbsp;y la Política de Privacidad de The Crowd Angel
              </label>
            </div>
            <div className="gap-20" />
            <div className="checkbox">
              <input
                type="checkbox"
                checked={this.props.publicity}
              />
              <label onClick={(e) => this.props.handleChange('publicity')(!this.props.publicity)}>
                Quiero recibir información sobre nuevas oportunidades de inversión y el ecosistema startup
              </label>
            </div>
            <div className="gap-20" />

            <button
              type="submit"
              className="btn btn-primary"
            >
              Registrarme
            </button>
            <div className="gap-20" />
            <ErrorMessagesComponent
              errorMessage={this.props.errorMessage}
            />
          </form>
        </div>
        <div className="modal-footer">
          <div className="gap-10" />
          <p className="text-center">
            ¿Ya tienes una cuenta?&nbsp;
            <a
              className="pointer"
              onClick={() => this.props.login()}
            >
              Inicia Sesión
              <span className="arrow-right-primary-dark" />
            </a>
          </p>
        </div>
      </div>
    );
  }

  private getTooltip(): string {
    return `
      La contraseña debe cumplir unos requisitos mínimos para ser validada.
      <ul>
          <li>
              <span className="square"/>
              Debe contener un mínimo de 8 carácteres
          </li>
          <li>
              <span className="check"/>
              Debe contener al menos una mayúscula
          </li>
          <li>
              <span className="square"/>
              Debe contener al menos un número
          </li>
          <li>
              <span className="square"/>
              Debe contener al menos un símbolo (#,@,%…)
          </li>
      </ul>`;
  }
}

export default RegisterComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/register/Register.component.tsx